import { Navigate } from "react-router-dom";
import Home from "./features/Home/Home";
import ListResellers from "./features/Resellers/ListResellers";
import ListMembers from "./features/Team/ListMembers";
import ListCustomers from "./features/Customers/ListCustomers";
import ListInvoices from "./features/Billing/ListInvoices";
import BillingReport from "./features/Reports/BillingReport";
import Provisioning from "./features/Provisioning/Provisioning"
import WhiteLabelling from "./features/WhiteLabelling/WhiteLabelling";
import PermissionGate, { PermissionType } from "./features/Permissions/PermissionGate";
import { getUserResellerType, ResellerType } from "./utils/getUserInformation";
import Reports from "./features/Reports/Reports";
import UsageReport from "./features/Reports/Usage/UsageReport";

const ROUTE_HOME_FALLBACK = <Navigate to="/" replace />;

const AppRoutes = [
	{
		index: true,
		path: "/",
		element: <Home />
	},
	{
		path: "/resellers",
		element: (
			<PermissionGate
				all={() => [PermissionType.ManageResellers]}
				fallback={ROUTE_HOME_FALLBACK}
			>
				<ListResellers />
			</PermissionGate>
		)
	},
	{
		path: "/teams",
		element: (
			<PermissionGate
				all={() => [PermissionType.ManageAdminUsers]}
				fallback={ROUTE_HOME_FALLBACK}
			>
				<ListMembers />
			</PermissionGate>
		)
	},
	{
		path: "/customers",
		element: (
			<PermissionGate
				all={() => [PermissionType.ManageUcSkillsAccess]}
				when={() => [ResellerType.NonBillable, ResellerType.Billable].includes(getUserResellerType())}
				fallback={ROUTE_HOME_FALLBACK}
			>
				<ListCustomers />
			</PermissionGate>
		)
	},
	{
		path: "/billing",
		element: (
			<PermissionGate
				all={() => [PermissionType.AccessInvoices]}
				when={() => [ResellerType.iTEL, ResellerType.Billable].includes(getUserResellerType())}
				fallback={ROUTE_HOME_FALLBACK}
			>
				<ListInvoices />
			</PermissionGate>
		)
	},
	{
		path: "/reports",
		element: (
			<PermissionGate
				all={() => [PermissionType.ViewReports]}
				when={() => [ResellerType.iTEL, ResellerType.Billable].includes(getUserResellerType())}
				fallback={ROUTE_HOME_FALLBACK}
			>
				<Reports />
			</PermissionGate>
		)
	},
	{
		path: "/billing-report",
		element: (
			<PermissionGate
				all={() => [PermissionType.ViewReports]}
				when={() => [ResellerType.iTEL, ResellerType.Billable].includes(getUserResellerType())}
				fallback={ROUTE_HOME_FALLBACK}
			>
				<BillingReport />
			</PermissionGate>
		)
	},
	{
		path: "/usage-report",
		element: (
			<PermissionGate
				all={() => [PermissionType.ViewReports]}
				when={() => [ResellerType.iTEL, ResellerType.Billable].includes(getUserResellerType())}
				fallback={ROUTE_HOME_FALLBACK}
			>
				<UsageReport />
			</PermissionGate>
		)
	},
	{
		path: "/provisioning",
		element: (
			<PermissionGate
				all={() => [PermissionType.ManageUcSkillsAccess]}
				when={() => getUserResellerType() === ResellerType.iTEL}
				fallback={ROUTE_HOME_FALLBACK}
			>
				<Provisioning />
			</PermissionGate>
		)
	},
	{
		path: "/white-labelling",
		element: (
			<PermissionGate
				all={() => [PermissionType.SetWhiteLabelling]}
				when={() => [ResellerType.NonBillable, ResellerType.Billable].includes(getUserResellerType())}
				fallback={ROUTE_HOME_FALLBACK}
			>
				<WhiteLabelling />
			</PermissionGate>

		)
	}
];

export default AppRoutes;
